import React, {useState} from 'react';
import Layout from './components/Layout';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from './components/TabPanel';
import BTCChain from './contents/BTCChain';
import EthChain from './contents/EthChain';
import Fireblocks from './contents/Fireblocks';
import {useCtx} from '../App'
function Blockchain({isAdmin} : any){
    const axeEnv = useCtx()
    console.log(axeEnv)
    const isAxmed = axeEnv === 'Production'
    const [currentTab, setCurrentTab] = useState(0);

    const handleTabChange = (event: any, newValue: any) => {
        setCurrentTab(newValue);
    };
    return (
        <Layout>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={currentTab} onChange={handleTabChange}>
                        <Tab label="External Ethereum" />
                        <Tab label="External BTC" />
                        {isAxmed ? null:  <Tab label="Fireblocks" />}
                    </Tabs>
                    <TabPanel value={currentTab} index={0}>
                        <EthChain isAdmin={isAdmin}/>
                    </TabPanel>
                    <TabPanel value={currentTab} index={1}>
                        <BTCChain />
                    </TabPanel>
                    {isAxmed ? null :<TabPanel value={currentTab} index={isAxmed? null : 2}>
                        <Fireblocks />
                    </TabPanel>}
                </Box>
            </Box>
        </Layout>
    );
}

export default Blockchain;